/**
 * Проверяет, входит ли значение в диапазон [min, max]
 */
export function includes(value: number, min: number, max: number): boolean {
  return value >= min && value <= max;
}
